export const CONTAINER_ID = 'query-visualization';
